var r=TypeError,F=9007199254740991,a=function(e){if(e>F)throw r("Maximum allowed index exceeded");return e};export{a as default};
